import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/Service/Home/home.service';
import { HomeModel } from 'src/app/Model/Home/home.model';
import { FeatureModel } from 'src/app/Model/Feature/feature.model';
import {environment} from '../../../environments/environment';
import {Router} from '@angular/router';
import {CustomformService} from './../../Service/CustomForm/customform.service';
import {CustomFormModel} from './../../Model/CustomForm/customform.model'
import {LeftTopBannerModel} from '../../Model/LeftTopBanner/leftTopBanner.model';
import {RightTopBannerModel} from '../../Model/RightTopBanner/RightTopBanner.model';
import { BlogsService } from 'src/app/Service/Blogs/blogs.service';
import {TournamentService} from './../../Service/Tournament/tournament.service';
import { componentRefresh } from '@angular/core/src/render3/instructions';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  homeData:HomeModel;
  featureModel:FeatureModel;
  featureList:FeatureModel;
  imageFolder:string;
  SelfServeArray=[];
  selectedSelfServes:string;
  CustomFormlist:CustomFormModel
  Customlist=[];
  id:number;
  data=[];
  leftTopBannerImage:any;
  rightTopBannerImage:any;
  RightTopBanner: RightTopBannerModel;
  LeftTopBanner:LeftTopBannerModel;
  blogList=[];
  tournamentList=[];
  leagueList=[];
  constructor(private _tournamentService:TournamentService, private _BlogService:BlogsService, private _HomeService: HomeService,private router: Router, private _CustomService:CustomformService) {
    this.homeData = new HomeModel();  
    this.featureModel = new FeatureModel(); 
    this.imageFolder=environment.imageFolder;
    this.selectedSelfServes= "";
   }

  ngOnInit() {
   this.GetHomeContent();
   this.GetFeature();
   this.GetSelectedForm(this.id);
   this.GetHome();
   this.GetBlogs();
   this.GetLeague();
   this.GetTournament();
  }

  GetBlogs(){
    this._BlogService.GetBlogs().subscribe(
      res=>{
        this.blogList =res.responseData;
    
      }
    )
     }
  GetHomeContent(){
    this._HomeService.GetHomeContent().subscribe(
    res =>{
      if (res.isSuccess) 
      {             
        this.homeData = res.responseData;
        this.data.push(this.homeData.selfServe)
        if( this.homeData.selfServe!=null && this.data[0]!="[]" )
        {
          this.SelfServeArray=JSON.parse(this.homeData.selfServe);  
          console.log(this.homeData.selfServe,"homecontent");    
            this.selectedSelfServes=this.SelfServeArray[0].value;      
        }                   
      }else{
        return false;
      }
    }
    )
  }


  GetFeature(){
    this._HomeService.GetFeatureContent().subscribe(
      res=>{
        this.featureList = res.responseData;
      }
    )
  }

  GetSelectedForm(id:number){
    var id =2
   this._HomeService.SelectedCustomForm(id).subscribe(
     res=>{
       this.Customlist=res.responseData;
     }
   )   
 }

 GetHome(){
 
  this._HomeService.GetHomeContent().subscribe(
   res => {
     if (res.isSuccess) {                 
      this.homeData = res.responseData;                
      if(this.homeData.leftTopBanner!=undefined && this.homeData.leftTopBanner!=null && this.homeData.leftTopBanner!=''){
        this.LeftTopBanner=JSON.parse( this.homeData.leftTopBanner);
        if(this.LeftTopBanner.fileName!=""){
          this.leftTopBannerImage=this.imageFolder+'/'+this.LeftTopBanner.fileName;
        } 
        else{
          this.leftTopBannerImage=null;
        }
       

      }else{
       
        this.leftTopBannerImage=null;
      }



      if(this.homeData.rightTopBanner!=undefined && this.homeData.rightTopBanner!=null && this.homeData.rightTopBanner!=''){
        this.RightTopBanner=JSON.parse( this.homeData.rightTopBanner);  
        if(this.RightTopBanner.fileName!="") {
          this.rightTopBannerImage=this.imageFolder+'/'+this.RightTopBanner.fileName;
        } 
        else
        {
          this.rightTopBannerImage=null;
        }

      }else{
  
        this.rightTopBannerImage=null;
      }
     }
       });         
     }

  GetTournament()
  {
    this._tournamentService.getTournament().subscribe(res=>
      {
        this.tournamentList= res.responseData;
      })
  }

  GetLeague()
  {
    
    this._tournamentService.getLeague().subscribe(res=>
      {
        this.leagueList= res.responseData;
      })
  }


}
